import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default  new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{ path: '/create-account', name: 'account.create', component: () => import('@/views/CreateAccount'), meta: { noLoginRequired: true, breadCrumb: 'Create Account' } },
		{ path: '/confirmation', redirect: '/' },
		{ path: '/confirmation/:hash', name: 'account.confirm', component: () => import('@/views/AccountConfirm'), meta: { noLoginRequired: true, breadCrumb: 'Create Confirmation' } },
		{ path: '/password', redirect: '/' },
		{ path: '/password/:hash', name: 'password.change', component: () => import('@/views/PasswordChange'), meta: { noLoginRequired: true, breadCrumb: 'Change Forgot Password' } },
		{ path: '/login', name: 'login', component: () => import('@/views/Login') },
		{ path: '/', name: 'dashboard', component: () => import('@/views/Dashboard') },
		{ path: '/courses', component: () => import('@/views/Therapy'), meta: { breadCrumb: "Programs" },
			children: [
				{ path: '', name: 'therapy', component: () => import('@/views/therapy/TherapyListing'), meta: { breadCrumb: "Listing" } },
				{ path: ':enrol_id', name: 'therapy.display', component: () => import('@/views/therapy/TherapyDisplay'), meta: { breadCrumb: "View Outline" } },
				{ path: ':enrol_id/stage/:stage_id', name: 'therapy.stage', component: () => import('@/views/therapy/TherapyStage'), meta: { breadCrumb: "View Content" }},
				{ path: ':enrol_id/stage/:stage_id/task/:task_id', name: 'therapy.content', component: () => import('@/views/therapy/TherapyStage'), meta: { breadCrumb: "View Content" }},
				/*
					children: [
						{ path: 'content/:task_id', name: 'therapy.content', component: () => import('@/views/therapy/TherapyStage'), meta: { breadCrumb: "View Content" } } // /:content_id+
					]
				},
				*/
				{ path: ':enrol_id/survey/:survey_id', name: 'therapy.survey', component: () => import('@/views/therapy/TherapySurvey'), meta: { breadCrumb: "Survey" } },
			]
		},
		{ path: '/messages', name: 'messages', component: () => import('@/views/Messages'),
			children: [
				{ path: 'folder/:id', name: 'messages.listing', component: () => import('@/views/Messages/Listing') },
				{ path: 'folder/:folder_id/messages/:id', name: 'messages.read', component: () => import('@/views/Messages/Read') },
				{ path: 'compose', name: 'messages.compose', component: () => import('@/views/Messages/Compose') },
				{ path: 'draft/:id', name: 'messages.draft', component: () => import('@/views/Messages/Compose') },
				{ path: 'reply/:folder_id/:id', name: 'messages.reply', component: () => import('@/views/Messages/Compose') },
				{ path: 'folders', name: 'messages.folders', component: () => import('@/views/Messages/ManageFolders') }
			]
		},
		{ path: '/profile', name: 'profile', component: () => import('@/views/Profile') },
		{ path: '/videos', name: 'videos', component: () => import('@/views/Videos') },
		{ path: '/logout', name: 'logout', component: () => import('@/views/Logout') },
		{ path: '/forums', name: 'forums', component: () => import('@/views/Forums/Forum'), meta: {title: 'Forum'} },
		{ path: '/forums/:forum_id/sections/:section_id/topics', name: 'topic', component: () => import('@/views/Forums/Topics'), meta: {title: 'Topics'} },
		// { path: '/forums/:forum_id/sections/:section_id/', name: 'topic', component: () => import('@/views/Forums/Topics'), meta: {title: 'Topics'} },
		{ path: '/forums/:forum_id/sections/:section_id/topics/:topic_id/posts', name: 'post', component: () => import('@/views/Forums/Posts'), meta: {title: 'Posts'} }
	


	]
});
